import { useState } from 'react';
import { withAsyncBoundary } from '@toss/async-boundary';
import { useBooleanState } from '@toss/react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { match, P } from 'ts-pattern';
import { useSingularSubscriptionCustomerName } from '../../../../services';
import { SingularSubscriptionPaymentResponse } from '../../../../types/PaymentTypes';
import { BusinessPaymentInvalidPage } from '../../business/BusinessPayments';
import { PaypleProvider } from '../hooks/usePayple';
import { AdditionalPaymentFormProvider } from '../paymentForm/AdditionalPaymentFormProvider';
import { ConfirmSingularSubscriptionEmail } from '../subscriptionPayment/components/ConfirmSingularSubscriptionEmail';
import { PaypleSingularSubscription, TossPaySingularSubscription } from '../subscriptionPayment/components/SingularPaymentMethod';
export const _SingularInvoice = () => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['business']);
  const paymentHashId = (router.query.id ?? '').toString();
  const [isInvalidPage, setInvalidPage] = useBooleanState(false);
  const [paymentInformation, setPaymentInformation] = useState<SingularSubscriptionPaymentResponse>();
  const {
    data: customerName,
    isFetched: isCustomerNameFetched
  } = useSingularSubscriptionCustomerName(paymentHashId, {
    enabled: !!paymentHashId
  });
  if (!isCustomerNameFetched || !customerName || isInvalidPage || !paymentHashId || paymentInformation && (!paymentInformation.orderId || paymentInformation.paymentRequest.status === 'CANCELED')) {
    throw new Error('invalid Payment Information');
  }
  const props = {
    businessName: customerName,
    paymentHashId,
    paymentInformation,
    productName: t('business:businessPage.productType.premium')
  };
  return <>
      {match(paymentInformation).with(P.nullish, () => <ConfirmSingularSubscriptionEmail paymentHashId={paymentHashId} businessName={customerName} onInvalidPage={setInvalidPage} onSetPaymentInfo={setPaymentInformation} />).with({
      spacePlan: {
        currency: 'KRW'
      }
    }, () => <AdditionalPaymentFormProvider zipCode={null}>
            {
      // @ts-ignore
      <TossPaySingularSubscription {...props} />}
          </AdditionalPaymentFormProvider>).otherwise(() => <PaypleProvider>
            <AdditionalPaymentFormProvider zipCode={null}>
              {
        // @ts-ignore
        <PaypleSingularSubscription {...props} />}
            </AdditionalPaymentFormProvider>
          </PaypleProvider>)}
    </>;
};
export const SingularInvoice = withAsyncBoundary(_SingularInvoice, {
  rejectedFallback: () => <BusinessPaymentInvalidPage />,
  pendingFallback: <></>
});